//加密 解密


// import JSEncrypt from 'jsencrypt/bin/jsencrypt.min';

// 密钥对生成 http://web.chacuo.net/netrsakeypair
import CryptoJS from 'crypto-js';
const publicKey = 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKoR8mX0rGKLqzcWmOzbfj64K8ZIgOdH\n' +
    'nzkXSOVOZbFu/TJhZ7rFAN+eaGkl3C4buccQd/EjEsj9ir7ijT7h96MCAwEAAQ==';

const privateKey = 'MIIBVAIBADANBgkqhkiG9w0BAQEFAASCAT4wggE6AgEAAkEAqhHyZfSsYourNxaY\n';

const loginKey = '2021123456789012';

// // 本地cookie加密
// export function encrypt(txt) {
//     const encryptor = new JSEncrypt();
//     encryptor.setPublicKey(publicKey); // 设置公钥
//     return encryptor.encrypt(txt); // 对数据进行加密
// }

// // 本地cookie解密
// export function decrypt(txt) {
//     const encryptor = new JSEncrypt();
//     encryptor.setPrivateKey(privateKey); // 设置私钥
//     return encryptor.decrypt(txt); // 对数据进行解密
// }

export function getLoginKey() {
    return loginKey;
}


/**
 * 加密
 * @param {String} word 加密内容
 * @returns
 */
// const SECRET_KEY = 'de43a68e4d184aa3';
export function cryptoEncryption(message, SECRET_KEY = 'de43a68e4d184aa3',) {
    let key = CryptoJS.enc.Utf8.parse(SECRET_KEY)
    let srcs = CryptoJS.enc.Utf8.parse(message);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: key,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return  encrypted.toString(); 
}


/**
 * 解密
 * @param {String} word 解密内容
 * @returns
 */
export function cryptoDecrypt(message, SECRET_KEY = 'de43a68e4d184aa3') {
    let key = CryptoJS.enc.Utf8.parse(SECRET_KEY)
    let decrypt = CryptoJS.AES.decrypt(message, key, {
        iv:key,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return decrypt.toString(CryptoJS.enc.Utf8)
}

/**
 *  第三方加密
 */
export function cryptoEncryptionThird(message, SECRET_KEY = 'b7a25216a14fb620',) {
    let key = CryptoJS.enc.Utf8.parse(SECRET_KEY)
    let srcs = CryptoJS.enc.Utf8.parse(message);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: key,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return  encrypted.toString(); 
}